import type { ReactNode } from 'react';

export interface TableColumn {
  /** TableRow.cells の参照キー。 */
  key: string;
  header: ReactNode;
}

export interface TableRow {
  key: string;
  cells: Record<string, ReactNode>;
}

export interface TableProps {
  columns: TableColumn[];
  rows: TableRow[];
  /** 読み上げ用の表の名前。 */
  label?: string;
}

/**
 * 実行履歴やmicroapp一覧に使う薄い表。列定義に無いcellsは描かないので、
 * 列の増減が行データ側の書き換えを強制しない。
 * 0件のときの文言は画面ごとに違うため、呼び出し側でEmptyStateへ分岐する。
 */
export function Table({ columns, rows, label }: TableProps) {
  return (
    <div className="table-scroll">
      <table className="table" aria-label={label}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} scope="col">
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.key}>
              {columns.map((column) => (
                <td key={column.key}>{row.cells[column.key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
